import { Routes, Route, Link, useLocation } from "react-router-dom";
import HomePage from "./pages/home";
import Registration from "./pages/registration";
import Profile from "./pages/profile";
import RafflePage from "./pages/raffle";
import FormBuilder from "./pages/editor";
import QRScanner from "./pages/qrScanner";
import Header from "./components/header";
import Footer from "./components/footer";
import CustomBottomNav from "./components/bottomNav";
import { useSelector } from "react-redux";
import { PaymentReceivedScreen } from "./pages/registration/PaymentStatusScreens";
import { PaymentFailedScreen } from "./pages/registration/PaymentStatusScreens";
import SettingsManager from "./utils/settings";
import NotFound from "./pages/notFound";

function App() {
  const location = useLocation();
  const state = useSelector((state) => state);
  let bottomNavType = null

  const getHeader = () => {
    switch (location.pathname) {
      case "/register":
        return <Header />
      default:
        return 
    }
  }


  const getFooter = () => {
    const path = location.pathname;

    if (/^\/[^/]+\/register$/.test(path)) {
      return; // Return nothing for /event-name/register
    }

    
    switch (path) {
      case "/register":
        return 
      case "/payment/success":
        return renderFooter()
      case "/payment/failed":
        return renderFooter()
      default:
        return renderFooter("customFooter")
    }
  }


  const renderFooter = (type = null) => {
    switch (type) {
      case "footer":
        return <Footer />
      case "customFooter":
        if (state?.user?.token) {
          return <CustomBottomNav />
        } else {
          renderFooter("footer")
        }
      default:
        break;
    }

  }
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {getHeader()}
      <main style={{ flex: 1, overflowY: "auto" }} className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* <Route path="/register" element={<Registration />} /> */}
          <Route path="/:eventId/register" element={<Registration />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/camera" element={<QRScanner />} />
          <Route path="/formbuilder" element={<FormBuilder />} />
          <Route path="/raffle" element={<RafflePage />} />
          <Route path="/:link" element={<HomePage />} />
          <Route path="/payment/success" element={<PaymentReceivedScreen />} />
          <Route path="/payment/failed" element={<PaymentFailedScreen />} />
          {/* <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </main>
      <SettingsManager />

      {getFooter()}
    </div>
  );
}

export default App;
